<template>
  <div>
    <HistoryBaseDesign
      :pageTitle="pageTitle"
      :searchHeaderInfo="searchHeaderInfo"
    >
      <template #searchDetailArea>
        <div class="px-9 py-7 d-flex">
          <div style="width: 460px">
            <InputFormNew
              v-model="searchDetailInfo.line1"
              :detail="searchDetail.line1"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="8"
            >
            </InputFormNew>
          </div>
          <div style="width: 440px" class="mt-12">
            <InputFormNew
              v-model="searchDetailInfo.line2"
              :detail="searchDetail.line2"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="inputFormStyle.contentsCols"
            >
            </InputFormNew>
          </div>
        </div>
      </template>
      <template #historyList>
        <HistoryList
          :historyList="historyList"
          :isOperation="true"
          :headers="headers"
          :itemKey="tableKey"
          :productListHeaders="productListHeaders"
          :pagerKey="pagerKey"
          @rowDialogMethodCommon="rowDialogMethodCommon"
          @pageMove="execGetShipList"
        >
        </HistoryList>
      </template>
    </HistoryBaseDesign>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import detail from './detail'
import headers from '@/views/sales/Ship/headers'

import InputFormNew from '@/components/items/Designs/InputFormNew'
import { HistoryBaseDesign, HistoryList } from '@/components/layouts'
import { commonUtil, customerUtil } from '@/util'
import mutationTypes from '@/store/mutationTypes'
import lu from '@/util/languageUtil'

export default {
  components: {
    HistoryBaseDesign,
    HistoryList,
    InputFormNew
  },
  data: () => {
    return {
      pageTitle: 'common.common_ship-history',
      pagerKey: 'salesShip',

      // Design
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 2,
        contentsCols: 12 - 2,
        inputItemHeight: '32px'
      },

      searchDetail: detail.detail,

      headers: headers.headers,
      tableKey: headers.tableKey,
      productListHeaders: headers.productListHeaders,

      searchHeaderInfo: {
        productName: '',
        InvalidData: true,
        checkboxLabel: 'sale.ship_hide-invalid-ship'
      },
      searchDetailInfo: {
        line1: {
          customerName: [],
          shipDate: { start: '', end: '' },
          shipStorage: {},
          shipStatus: {}
        },
        line2: {
          saleInfo: {
            saleNumber: '',
            remittanceNumber: '',
            placeholders: [
              lu.t('refund.refund_target-order-number'),
              lu.t('ship.ship_ship-history')
            ]
          },
          productInfo: {
            number: '',
            category: {}
          }
        }
      },

      historyList: [],
      customerList: []
    }
  },
  async created() {
    this.initPager()

    // 初期表示用の設定
    this.searchDetailInfo.line1.shipDate = {
      start: commonUtil.getFirstDateOneMonthAgo(),
      end: commonUtil.getLastDateThisMonth()
    }
    await this.execGetShipList()
  },
  methods: {
    ...mapActions('Ship', ['getShipListFromApi']),
    ...mapMutations('UI', [
      mutationTypes.UI_SET_PAGE,
      mutationTypes.UI_SET_PAGE_COUNT
    ]),
    async execGetShipList() {
      customerUtil.getCustomer() // CU01_顧客一覧取得

      const getList = await this.getShipListFromApi({
        pageType: 'ShipHistory',
        searchParameter: {
          searchDetailInfo: this.searchDetailInfo,
          searchHeaderInfo: this.searchHeaderInfo,
          page: this.pageInfo[this.pagerKey].page
        }
      })
      this.historyList = getList.data
        .sort((a, b) => {
          const keyName = 'shipId'
          if (a[keyName] < b[keyName]) return 1
          if (a[keyName] > b[keyName]) return -1
          return 0
        })
        .map((ele, Index) => {
          ele.panelIndex = Index + 1
          ele.beforeCompleteFlgTmp = this.getBeforeCompleteFlgTmp(ele)
          return ele
        })
    },
    getBeforeCompleteFlgTmp(rec) {
      return rec.status == 1
    },

    rowDialogMethodCommon(...args) {
      const [dialogName, info] = args

      switch (dialogName) {
        case 'reload': {
          this.execGetShipList()
          break
        }
      }
    },
    rowDialogMethodCommonDataSet(type, rowItems, pageInfoData) {
      const dataInfo = this.dialogs[type]
      dataInfo.rowItems = rowItems
      dataInfo.pageInfoData = pageInfoData
      dataInfo.dialog = true
    },
    rowDialogMethodShip(type, ...args) {
      const [rowItems, pageInfoData] = args
      this.rowDialogMethodCommonDataSet(type, rowItems, pageInfoData)
    },
    initPager() {
      this[mutationTypes.UI_SET_PAGE]({ index: 1, key: this.pagerKey })
      this[mutationTypes.UI_SET_PAGE_COUNT]({ length: 1, key: this.pagerKey })
    }
  },
  computed: {
    ...mapGetters('UI', ['pageInfo'])
  },
  watch: {
    searchDetailInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.initPager()
        this.execGetShipList()
      }
    },
    searchHeaderInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.initPager()
        this.execGetShipList()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.inputFormStyle {
  &::v-deep {
    .MultipleSelectCustomerName {
      width: 822px;
    }
  }
}
</style>
